export const syntheticModels = {
    id: "synthetic",
    name: "Synthetic",
    api: "https://api.synthetic.new/v1",
    npm: "@ai-sdk/openai-compatible",
    doc: "https://synthetic.new/pricing",
    env: ["SYNTHETIC_API_KEY"],
    models: {
        "hf:meta-llama/Llama-3.1-405B-Instruct": {
            id: "hf:meta-llama/Llama-3.1-405B-Instruct",
            name: "Llama-3.1-405B-Instruct",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2023-12",
            release_date: "2024-07-23",
            last_updated: "2024-07-23",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 3,
                output: 3,
            },
            limit: {
                context: 128000,
                output: 32768,
            },
        },
        "hf:meta-llama/Llama-4-Maverick-17B-128E-Instruct-FP8": {
            id: "hf:meta-llama/Llama-4-Maverick-17B-128E-Instruct-FP8",
            name: "Llama-4-Maverick-17B-128E-Instruct-FP8",
            attachment: true,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2024-08",
            release_date: "2025-04-05",
            last_updated: "2025-04-05",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.22,
                output: 0.88,
            },
            limit: {
                context: 524000,
                output: 4096,
            },
        },
        "hf:meta-llama/Llama-3.1-70B-Instruct": {
            id: "hf:meta-llama/Llama-3.1-70B-Instruct",
            name: "Llama-3.1-70B-Instruct",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2023-12",
            release_date: "2024-07-23",
            last_updated: "2024-07-23",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.9,
                output: 0.9,
            },
            limit: {
                context: 128000,
                output: 32768,
            },
        },
        "hf:meta-llama/Llama-4-Scout-17B-16E-Instruct": {
            id: "hf:meta-llama/Llama-4-Scout-17B-16E-Instruct",
            name: "Llama-4-Scout-17B-16E-Instruct",
            attachment: true,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2024-08",
            release_date: "2025-04-05",
            last_updated: "2025-04-05",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.15,
                output: 0.6,
            },
            limit: {
                context: 328000,
                output: 4096,
            },
        },
        "hf:meta-llama/Llama-3.3-70B-Instruct": {
            id: "hf:meta-llama/Llama-3.3-70B-Instruct",
            name: "Llama-3.3-70B-Instruct",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2023-12",
            release_date: "2024-12-06",
            last_updated: "2024-12-06",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.9,
                output: 0.9,
            },
            limit: {
                context: 128000,
                output: 32768,
            },
        },
        "hf:meta-llama/Llama-3.1-8B-Instruct": {
            id: "hf:meta-llama/Llama-3.1-8B-Instruct",
            name: "Llama-3.1-8B-Instruct",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2023-12",
            release_date: "2024-07-23",
            last_updated: "2024-07-23",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.2,
                output: 0.2,
            },
            limit: {
                context: 128000,
                output: 32768,
            },
        },
        "hf:deepseek-ai/DeepSeek-V3.1": {
            id: "hf:deepseek-ai/DeepSeek-V3.1",
            name: "DeepSeek V3.1",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            release_date: "2025-08-21",
            last_updated: "2025-08-21",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 0.56,
                output: 1.68,
            },
            limit: {
                context: 128000,
                output: 128000,
            },
        },
        "hf:deepseek-ai/DeepSeek-V3": {
            id: "hf:deepseek-ai/DeepSeek-V3",
            name: "DeepSeek V3",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2024-07",
            release_date: "2025-01-20",
            last_updated: "2025-05-29",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 1.25,
                output: 1.25,
            },
            limit: {
                context: 128000,
                output: 128000,
            },
        },
        "hf:deepseek-ai/DeepSeek-V3-0324": {
            id: "hf:deepseek-ai/DeepSeek-V3-0324",
            name: "DeepSeek V3 (0324)",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            release_date: "2025-08-01",
            last_updated: "2025-08-01",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 1.2,
                output: 1.2,
            },
            limit: {
                context: 128000,
                output: 128000,
            },
        },
        "hf:deepseek-ai/DeepSeek-R1": {
            id: "hf:deepseek-ai/DeepSeek-R1",
            name: "DeepSeek R1",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2025-01",
            release_date: "2025-01-20",
            last_updated: "2025-01-20",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.55,
                output: 2.19,
            },
            limit: {
                context: 128000,
                output: 128000,
            },
        },
        "hf:deepseek-ai/DeepSeek-R1-0528": {
            id: "hf:deepseek-ai/DeepSeek-R1-0528",
            name: "DeepSeek R1 (0528)",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            release_date: "2025-08-01",
            last_updated: "2025-08-01",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 3,
                output: 8,
            },
            limit: {
                context: 128000,
                output: 128000,
            },
        },
        "hf:zai-org/GLM-4.5": {
            id: "hf:zai-org/GLM-4.5",
            name: "GLM 4.5",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2025-04",
            release_date: "2025-07-28",
            last_updated: "2025-07-28",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.55,
                output: 2.19,
            },
            limit: {
                context: 128000,
                output: 96000,
            },
        },
        "hf:moonshotai/Kimi-K2-Instruct": {
            id: "hf:moonshotai/Kimi-K2-Instruct",
            name: "Kimi K2",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2024-10",
            release_date: "2025-07-11",
            last_updated: "2025-07-11",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.6,
                output: 2.5,
            },
            limit: {
                context: 128000,
                output: 32768,
            },
        },
        "hf:moonshotai/Kimi-K2-Instruct-0905": {
            id: "hf:moonshotai/Kimi-K2-Instruct-0905",
            name: "Kimi K2 0905",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2024-10",
            release_date: "2025-09-05",
            last_updated: "2025-09-05",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 1.2,
                output: 1.2,
            },
            limit: {
                context: 262144,
                output: 32768,
            },
        },
        "hf:Qwen/Qwen2.5-Coder-32B-Instruct": {
            id: "hf:Qwen/Qwen2.5-Coder-32B-Instruct",
            name: "Qwen2.5-Coder-32B-Instruct",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: false,
            knowledge: "2024-10",
            release_date: "2024-11-11",
            last_updated: "2024-11-11",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.8,
                output: 0.8,
            },
            limit: {
                context: 32768,
                output: 32768,
            },
        },
        "hf:Qwen/Qwen3-Coder-480B-A35B-Instruct": {
            id: "hf:Qwen/Qwen3-Coder-480B-A35B-Instruct",
            name: "Qwen 3 Coder 480B",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2025-04",
            release_date: "2025-07-23",
            last_updated: "2025-07-23",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 2,
                output: 2,
            },
            limit: {
                context: 256000,
                output: 32000,
            },
        },
        "hf:Qwen/Qwen3-235B-A22B-Thinking-2507": {
            id: "hf:Qwen/Qwen3-235B-A22B-Thinking-2507",
            name: "Qwen3 235B A22B Thinking 2507",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2025-04",
            release_date: "2025-07-25",
            last_updated: "2025-07-25",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.65,
                output: 3,
            },
            limit: {
                context: 256000,
                output: 32000,
            },
        },
        "hf:Qwen/Qwen3-235B-A22B-Instruct-2507": {
            id: "hf:Qwen/Qwen3-235B-A22B-Instruct-2507",
            name: "Qwen 3 235B Instruct",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2025-04",
            release_date: "2025-04-28",
            last_updated: "2025-07-21",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.2,
                output: 0.6,
            },
            limit: {
                context: 256000,
                output: 32000,
            },
        },
        "hf:openai/gpt-oss-120b": {
            id: "hf:openai/gpt-oss-120b",
            name: "GPT OSS 120B",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            release_date: "2025-08-05",
            last_updated: "2025-08-05",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.1,
                output: 0.1,
            },
            limit: {
                context: 128000,
                output: 32768,
            },
        },
    },
};
export default syntheticModels;
//# sourceMappingURL=synthetic.js.map